import { render, staticRenderFns } from "./login-mss.vue?vue&type=template&id=53906519&scoped=true&"
import script from "./login-mss.vue?vue&type=script&lang=js&"
export * from "./login-mss.vue?vue&type=script&lang=js&"
import style0 from "./login-mss.vue?vue&type=style&index=0&id=53906519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53906519",
  null
  
)

export default component.exports